import { Box, ButtonBase, Typography, useTheme } from "@mui/material";
import React from "react";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import { testOrgs } from "../../pages/organizations/utils/testData";
import { BCPShop } from "../icons/bcp/BCPIcons";
import VerifiedIcon from "../icons/VerifiedIcon";

export default function OrganizationCardSmall(props) {
  const { organize, buttonSx, distributorView } = props;

  let organization = props?.organization;

  const theme = useTheme();
  const mode = theme.palette.mode;

  if (testOrgs?.[organization?.id]) {
    organization = { ...organization, ...testOrgs[organization?.id] };
  }

  return (
    <ButtonBase
    href={`${organize ? "/organize" : ""}/organization/${organization?.id}`}
      sx={{
        backgroundColor:
          mode === "dark" ? "background.tertiary" : "background.secondary",
        borderRadius: 1,
        pl: 2,
        pr: 2,
        pt: 1,
        pb: 1,
        width: "100%",
        height: "100%",
        border: `1px solid ${theme.palette.divider}`,
        ...buttonSx,
      }}
      focusRipple
    >
      {(organization?.name ||
        organization?.ownerFirstName ||
        organization?.ownerLastName ||
        organization?.owner?.firstName ||
        organization?.owner?.lastName) && (
        <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "50%",
              backgroundColor:
                mode === "dark"
                  ? "background.tertiary"
                  : "background.secondary",
              border: `1px solid ${theme.palette.divider}`,
              p: 1.5,
              mr: 1,
              ...(organization?.profileUrl && {
                backgroundImage: `url(${organization?.profileUrl})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }),
              width: 48,
              height: 48,
              // width: organization?.profileUrl ? 48 : 40,
              // height: organization?.profileUrl ? 48 : 40,
            }}
          >
            {!organization?.profileUrl && <BCPShop />}
          </Box>

          <Box>
            <Typography
              sx={{
                fontWeight: 700,
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              {(organization?.name).trim()}
              {organization?.isVerified && <VerifiedIcon />}
            </Typography>
            {distributorView && (
              <Typography variant="body1">
                {`${getEnvironmentVariable("APP_NAME")} ID: ${
                  organization?.id
                }`}
              </Typography>
            )}
            {getOrgType(organization) && (
              <Typography variant="body1">
                {`${getOrgType(organization)} ${
                  getOrgLocation(organization)
                    ? `in ${getOrgLocation(organization)}`
                    : ``
                }`}
              </Typography>
            )}
          </Box>
          {/* {organize && (
            <IconButton sx={{ ml: "auto" }}>
              <BCPEllipsisVertical />
            </IconButton>
          )} */}
          {/* Potentially options for following, unfollowing from dropdown menu. */}
        </Box>
      )}
    </ButtonBase>
  );
}

function getOrgType(org) {
  if (org) {
    const orgTypes = org?.organizationTypes;

    if (orgTypes?.club) {
      return "Gaming Club";
    } else if (orgTypes?.store) {
      return "Game Store";
    } else if (orgTypes?.publisher) {
      return "Publisher";
    } else if (orgTypes?.tournamentOrganizer) {
      return "Independent Tournament Organizer";
    } else {
      return null;
    }
  } else {
    return null;
  }
}

function getOrgLocation(org) {
  if (!org?.location) return null;
  if (typeof org.location === "object") {
    if (!Object.keys(org.location).length) return null;
  }

  const city = org?.location.city;
  const state = org?.location.state;
  const country = org?.location.country;

  const location = `${city ? `${city}, ` : ``}${state ? `${state} ` : ``}${
    country !== "United States" ? `${city || state ? ", " : ""}${country}` : ``
  }`.trim();

  if (location === "" || location === "undefined") return null;

  return location;
}
